import Config from 'Config';

import { createApiClient } from '../api-client-factory';

import { CreateAgentRequest, ErrorResponse } from './types';

const client = createApiClient(`${Config.livechat_api_url}/v3.5/configuration/action`);

/**
 * LiveChat API client.
 */
export const livechatClient = {
  /**
   * Creates new agent.
   */
  createAgent: async (data: CreateAgentRequest, token: string) =>
    client.post<unknown, ErrorResponse>('create_agent', data, token),
};
